import { toUnitNumber } from './number'

export const formatNumberWithUnit = (num: number) => {
  const unitNumber = toUnitNumber(num)
  return `${unitNumber.value}${unitNumber.unit}`
}

export const ommitText = (s: string, len: number) =>
  s.length > len ? `${s.substring(0, len)}...` : s
